import config from 'configDir/index';
import { get } from './http';

// 近30天行业违章情况
const statTradeViolationService = get('/im/stat_trade_violation', config.governanceUrl);
// 近30天企业违章情况
const statCompanyViolationService = get('/im/stat_company_violation', config.governanceUrl);

// 行业违章趋势
const statTradeViolationTrendService = get('/im/stat_trade_violation_trend', config.governanceUrl);

// 地区违章趋势
const statAreaViolationTrendService = get('/im/stat_area_violation_trend', config.governanceUrl);

// 累计未治理违章
const statUnProcessViolationService = get('/im/stat_unprocess_violation', config.governanceUrl);

// 未完成安全学习企业数
const statUnDoneEduService = get('/im/stat_undone_edu', config.governanceUrl);

export {
  statTradeViolationService,
  statTradeViolationTrendService,
  statUnProcessViolationService,
  statUnDoneEduService,
  statAreaViolationTrendService,
  statCompanyViolationService,
};
